"use client";

import * as React from "react";
import { createContext, useContext, useState } from "react";

type CommonContextType = {
    handleHamburgerClick: Function;
    menuOpen: boolean;
};

export enum DownloadButtonState {
    Initial,
    DownloadClicked,
    DownloadStart,
    Downloading,
    DownloadAgain,
}

const commonContextDefault: CommonContextType = {
    handleHamburgerClick: () => {},
    menuOpen: false,
};

export const CommonContextData =
    createContext<CommonContextType>(commonContextDefault);

export const useDownloadContext = () => {
    return useContext(CommonContextData);
};

export const CommonContext = (props: React.PropsWithChildren<any>) => {
    const [menuOpen, setMenuOpen] = useState<boolean>(false);

    // Function to toggle side drawer menu state
    const handleHamburgerClick = (): void => {
        if (menuOpen) {
            setMenuOpen(false);
        } else {
            setMenuOpen(true);
        }
    };

    const value = {
        locale: props.locale,
        handleHamburgerClick,
        menuOpen,
    };

    return (
        <CommonContextData.Provider value={value}>
            {props.children}
        </CommonContextData.Provider>
    );
};
